// extracted by mini-css-extract-plugin
export default {"systemMessageWrapper":"styles_systemMessageWrapper__R06J9","systemMessage":"styles_systemMessage__+cOeX","text":"styles_text__o0B4T"};